export const usePluginRefreshProduct = () => {
    const extensions = () => {
        return {
            canRefreshProduct() {
                if (! this.permission.has('write')) {
                    this.logger.error('没有重载权限')
                    return false
                }

                const bn = this.BizNode[this.componentType ?? this.productType]

                if ('function' !== typeof bn.readMap) {
                    this.logger.error('不支持重载')
                    return false
                }

                return true
            },

            async cmdRefreshProduct() {
                await this.runAction(
                    () => this.execute(
                        () => this.refreshProduct()
                    ),

                    {action: '重载模型制品'},
                )

                this.selectNodes([this.root])
            },

            async refreshProduct() {
                const {data, root} = await (async () => {
                    if (this.componentId) {
                        const bn = this.BizNode[this.componentType]

                        return bn.readMap({
                            id: this.componentId,
                            ownerId: this.productId,
                        })
                    }
                    else {
                        const bn = this.BizNode[this.productType]
                        return bn.readMap({pkid: this.productId})
                    }
                })()

                this.data = {...this.data, ...data}
                const _n = this.nodeProxy(this.root)
                await _n.replace(root)
            },

            useCanRefreshProduct() {
                this.usePermission()
                return this.canRefreshProduct()
            },
        }
    }

    return {extensions}
}
